import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-roll-back-message',
  templateUrl: './roll-back-message.component.html',
  styleUrls: ['./roll-back-message.component.scss'],
})
export class RollBackMessageComponent {
 ActionValue:any
  constructor(
    public dialogRef: MatDialogRef< RollBackMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ActionValue=data[0].action
  }

  closeDialog() {
    this.dialogRef.close();
  }
}